import {
    $getSelection,
    $isRangeSelection,
    LexicalEditor
} from "lexical"

const debug = false
// const debug = "lexicalGetSelectedText"

export function lexicalGetSelectedText(editor: LexicalEditor): string {
    let selectedText = "";

    editor.read(() => {
        const selection = $getSelection();

        if ($isRangeSelection(selection)) {
            selectedText = selection.getTextContent();
            debug && console.log(debug, selectedText);
        }
    });

    return selectedText;
}